import { orderCompaniesAndStations } from "helpers/companiesNormalized";
import { getStations } from "helpers/companiesNormalized";
import { convertToObjById } from "helpers/convertToObject";

export const LOAD_COMPANIES_FOR_ITEMS = 'LOAD_COMPANIES_V2';
export const SET_COMPANIES_FOR_ITEMS = 'SET_COMPANIES_V2';

const initialState = {
    loading: false,
    companies: {},
    companiesList: [],
    stations: {},
    stationsList: [],
}

export const companiesItemsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_COMPANIES_FOR_ITEMS:
            return {
                ...state, loading: true
            }

        case SET_COMPANIES_FOR_ITEMS:
            const addingLabel = action.payload.map(company => {
                return {
                    ...company,
                    stations: company.stations.map(station => {
                        return {
                            ...station,
                            label: station.name,
                            value: station.id
                        }
                    })
                }
            })
            const companies = orderCompaniesAndStations(addingLabel)
            return {
                ...state,
                companies: convertToObjById(companies),
                stations: convertToObjById(getStations(addingLabel)),
                stationsList: action.payload
                    .map(({ stations }) => stations)
                    .flat()
                    .map(station => ({ ...station, value: station.id, label: station.name }))
                    .sort((a, b) => a.name.localeCompare(b.name)),
                companiesList: companies.sort((a, b) => a.name.localeCompare(b.name)),
                loading: false
            }

        default:
            return state
    }
}